module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_XavierHouot_Still.12ff7ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_XavierHouot_Still.jpg
// module id = cGx6
// module chunks = 0